import { Suspense, useMemo } from "react"
import { DelayedProgress } from "components/new-stuff/layout/RouteFallback"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { ZIndex } from "constants/zIndex"

import PayrollConfigurationTabBar, {
  PAYROLL_CONFIG_NAV_TABS,
} from "./paygrades/PayrollConfigurationTabBar"

const PayrollConfigurations: React.FC<{}> = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  const activeKey = useMemo(() => {
    const exact = PAYROLL_CONFIG_NAV_TABS.find((tab) => tab.to === pathname)
    if (exact) return exact.key
    const prefix = PAYROLL_CONFIG_NAV_TABS.find(
      (tab) => tab.to && pathname.startsWith(`${tab.to}/`)
    )
    return prefix?.key ?? ""
  }, [pathname])

  return (
    <>
      <PayrollConfigurationTabBar
        activeKey={activeKey}
        navigate={navigate}
      />
      <div className="w-full mx-auto flex flex-col gap-4">
        <div className="w-full bg-[#ededed] min-h-screen">
          <div className="w-full h-full px-0 py-5 md:px-3 lg:px-4 wrapper">
            <Suspense
              fallback={
                <div
                  className="fixed right-0 top-32 bottom-0 left-0 md:left-[var(--sidenav-w)] transition-[left] duration-300 ease-in-out motion-reduce:transition-none flex justify-center items-center h-[calc(100vh-80px)] bg-white"
                  style={{
                    zIndex: ZIndex.LoadingOverlay,
                  }}
                >
                  <DelayedProgress />
                </div>
              }
            >
              <Outlet />
            </Suspense>
          </div>
        </div>
      </div>
    </>
  )
}

export default PayrollConfigurations
